/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import React from "react";

import LanguageSelection from "@/shared/components/language/LanguageSelectionMenu";
import Typography from "@mui/material/Typography";

import Logo from "../../../components/Logo/Logo";
import { useMediaQueries } from "../../../shared";
import {
  backgroundGridStyleOverrides,
  formNamestyleOverrides,
  secondaryTextStyleOverrides
} from "../constants";
import { useStyles } from "../styles";
import Contacts from "./Contacts";

interface IAuthContainerProps {
  formName: string;
  secondaryText?: string | React.ReactNode;
  children: React.ReactNode;
}

const AuthContainer = ({
  children,
  formName,
  secondaryText
}: IAuthContainerProps) => {
  const { fromMd } = useMediaQueries();

  const {
    authGrid,
    itemGrid,
    logo,
    loginContentContainer,
    innerLoginContentContainer,
    loginContentHeaders
  } = useStyles();

  const bgImageDesktop = "/backgrounds/auth-background-desktop.webp";

  return (
    <section
      className="remaining-height"
      css={css({ height: "100vh" })}
      data-testid="auth-container"
    >
      <div css={css(authGrid)}>
        <div css={css(itemGrid)}>
          <div
            css={css(logo, {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            })}
          >
            <Logo />

            <LanguageSelection />
          </div>

          <div css={css(loginContentContainer)}>
            <div css={css(innerLoginContentContainer)}>
              <div css={css(loginContentHeaders)}>
                <Typography variant="h4" sx={formNamestyleOverrides}>
                  {formName}
                </Typography>
                <Typography
                  variant="body1Medium"
                  sx={secondaryTextStyleOverrides}
                >
                  {secondaryText}
                </Typography>
              </div>

              <div>{children}</div>

              <Contacts />
            </div>
          </div>
        </div>

        {fromMd && (
          <div css={css(backgroundGridStyleOverrides(bgImageDesktop))} />
        )}
      </div>
    </section>
  );
};

export default AuthContainer;
